<div class="row">
    <div class="col-lg-12 col-xl-10 offset-xl-1">


        <form [formGroup]="form" autocomplete="off" novalidate [autocomplete]="'off'" (ngSubmit)="setBaseItems()">

            <h3 class="mb-30">Supplier base cost and weight</h3>

                <div class="mb-3 text-center p-3" style="background-color: aliceblue;">
                    <p class="m-0">
                        Does the supplier offer bespoke sawn products
                        <a (click)="toggleBaseCost()">
                            <i class="toggle fa"
                               [ngClass]="{'fa-toggle-on text-success': enableBaseCost, 'fa-toggle-off' : !enableBaseCost}"></i>
                        </a>

                    </p>
                </div>

                <div class="mb-3 row">
                <label class="col-sm-6 col-form-label">Base cost per cubic metre</label>
                <div class="col-sm-6">
                    <input
                        type="text"
                        [readOnly]="!enableBaseCost"
                        autocomplete="new-password"
                        class="form-control bordered"
                        [ngClass]="{'is-invalid' : form.controls.baseCost.invalid && form.controls.baseCost.dirty}"
                        formControlName="baseCost"
                        placeholder="Cost per cubic metre">
                    <div class="invalid-feedback">Enter cost</div>
                </div>
            </div>

            <div class="mb-3 row">
                <label class="col-sm-6 col-form-label">Base weight per cubic metre</label>
                <div class="col-sm-6">
                    <input
                        type="text"
                        autocomplete="new-password"
                        class="form-control bordered"
                        [ngClass]="{'is-invalid' : form.controls.baseWeight.invalid && form.controls.baseWeight.dirty}"
                        formControlName="baseWeight"
                        placeholder="Weight per cubic metre">
                    <div class="invalid-feedback">Enter weight</div>
                </div>
            </div>

            <div class="row">
                <div class="col-12 text-end">
                    <button
                        [disabled]="form.invalid"
                        class="btn btn-round btn-primary mt-4"
                        type="submit"
                        tabindex="3">
                        Continue
                    </button>
                </div>
            </div>
            <div class="mt-2 text-end">
                <p>Base costs will be saved upon clicking 'Continue'</p>
            </div>

        </form>

    </div>
</div>
